/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class ModelDialog extends SiteEntityDialog<ModelRow, any> {
        protected getFormKey() { return ModelForm.formKey; }
        protected getIdProperty() { return ModelRow.idProperty; }
        protected getLocalTextPrefix() { return ModelRow.localTextPrefix; }
        protected getNameProperty() { return ModelRow.nameProperty; }
        protected getService() { return ModelService.baseUrl; }

        protected form = new ModelForm(this.idPrefix);

        constructor() {
            super();

            this.form.Levels.addValidationRule(this.uniqueName, e => {
                if (this.form.Levels.value < 1 ||
                    this.form.Levels.value > 10)
                    return "Number of levels must be between 1 and 10!";
            });

            this.form.Levels.change(e => {
                this.updateLevels();    
            });
        }

        afterLoadEntity() {
            super.afterLoadEntity();

            this.updateLevels();
        }

        private updateLevels() {
            var levels = this.form.Levels.value;
            if (levels < 1)
                levels = 1;
            else if (levels > 10)
                levels = 10;

            for (var l = 1; l <= 10; l++) {
                this.byId('LevelName' + l).closest('.field').toggle(l <= levels);
                Serenity.EditorUtils.setRequired(this.byId('LevelName' + l).getWidget(Serenity.Widget), l <= levels);
            }
        }
    }
}